import { useFormContext } from "react-hook-form"
import { useTranslation } from "react-i18next"
import { TextArea } from "@/components/ui/input"
import NewsSectionDurationForm from "@/modules/admin/news/components/sections/news-form-section-durations"
import { NewsSectionUserLevelCriticalityForm } from "@/modules/admin/news/components/sections/news-form-section-level-criticality"
import NewsSectionUserRolesForm from "@/modules/admin/news/components/sections/news-form-section-userRoles"
import { NewsForm } from "@/modules/admin/news/types"
import { SofiaEnvironment } from "@/sofia-environment"

const CreateEditNewsForm = () => {
  const { t } = useTranslation()

  const form = useFormContext<NewsForm>()

  const {
    register,
    formState: { errors: formErrors },
  } = form

  return (
    <div className="bg-background-subdued overflow-y-auto">
      <div className="bg-surface rounded-md p-6">
        <div className="grid auto-cols-max grid-cols-1 gap-y-4">
          <NewsSectionUserRolesForm />
          <NewsSectionDurationForm />
          <NewsSectionUserLevelCriticalityForm />
          <TextArea
            {...register("germanContent")}
            label={t("admin.news.form.messageGerman")}
            required
            error={formErrors.germanContent?.message}
            translateError
            errorClasses="truncate"
            textLimit={250}
          />
          <TextArea
            {...register("englishContent")}
            label={t("admin.news.form.messageEnglish")}
            required
            error={formErrors.englishContent?.message}
            translateError
            errorClasses="truncate"
            textLimit={250}
          />
          {!SofiaEnvironment.AreEndUsersOnEnvironment && (
            <>
              <TextArea
                {...register("frenchContent")}
                label={t("admin.news.form.messageFrench")}
                error={formErrors.frenchContent?.message}
                translateError
                errorClasses="truncate"
                textLimit={250}
              />
              <TextArea
                {...register("italianContent")}
                label={t("admin.news.form.messageItalian")}
                error={formErrors.italianContent?.message}
                translateError
                errorClasses="truncate"
                textLimit={250}
              />
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default CreateEditNewsForm
